export type ShellLanguage = 'pl' | 'en';

export const SHELL_LANGUAGES: ShellLanguage[] = ['pl', 'en'];

/** Kod języka z i18n lub z profilu (`pl`, `en-US`, …) sprowadzony do obsługiwanych języków. */
export function normalizeLanguage(code: string | undefined | null): ShellLanguage {
  return code?.toLowerCase().startsWith('pl') ? 'pl' : 'en';
}
